import "./ReportAIInsights.css";

/**
 * ReportAIInsights — shows AI Mentor recommendations + field insights.
 * Pulls from res.sectionScores.aiResults and res.sectionScores.aiReport.
 *
 * Props:
 *   res      — full report object from API
 *   extended — if true, shows full executive summary (used in Report B)
 */
export default function ReportAIInsights({ res, extended = false }) {
  const scores   = res?.sectionScores ?? {};
  const aiResult = scores.aiResults  ?? {};
  const aiReport = scores.aiReport   ?? {};

  const recommendations = Array.isArray(aiReport.recommendations)
    ? aiReport.recommendations
    : [];

  const insights = Array.isArray(aiResult.insights)
    ? aiResult.insights
    : [];

  const executiveSummary = aiReport.executiveSummary || "";
  const modelUsed        = aiResult.modelUsed || "AI";

  const hasContent = recommendations.length > 0 || insights.length > 0 || executiveSummary;
  if (!hasContent) return null;

  return (
    <div className="ai-insights-section">
      <div className="ai-insights-header">
        <span className="ai-badge">✦ AI MENTOR</span>
        <span className="ai-model-tag">Powered by {modelUsed === "claude" ? "Claude" : modelUsed === "gemini" ? "Gemini" : "AI"}</span>
      </div>

      {extended && executiveSummary && (
        <div className="ai-exec-summary">
          <div className="ai-block-title">Executive Summary</div>
          <p className="ai-summary-text">{executiveSummary}</p>
        </div>
      )}

      {recommendations.length > 0 && (
        <div className="ai-recommendations">
          <div className="ai-block-title">Top Recommendations</div>
          <ol className="ai-rec-list">
            {recommendations.slice(0, extended ? 8 : 5).map((rec, i) => (
              <li key={i} className="ai-rec-item">
                <span className="ai-rec-number">{i + 1}</span>
                <span className="ai-rec-text">{rec}</span>
              </li>
            ))}
          </ol>
        </div>
      )}

      {insights.length > 0 && (
        <div className="ai-field-insights">
          <div className="ai-block-title">Field-Level Analysis</div>
          <div className="ai-insights-grid">
            {insights.map((ins, i) => (
              <div key={i} className="ai-insight-card">
                <div className="ai-insight-field">{formatFieldName(ins.field)}</div>
                <div className="ai-insight-note">{ins.note}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

function formatFieldName(key) {
  const map = {
    problem:         "Problem Statement",
    ideaDescription: "Solution Description",
    revenueStreams:   "Revenue Streams",
    costStructure:   "Cost Structure",
    northStarMetric: "North Star Metric",
    ideaTitle:       "Startup Title",
  };
  return map[key] || key;
}
